<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="提单号">
              <a-input v-model="queryParam.bill_of_lading_number" placeholder="提单号" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="cargoCategory" slot-scope="text, record">
        <a-popover v-if="record.detail" :title="trade_lading_bill_type[text]">
          <a>{{ trade_lading_bill_type[text] || '无' }}</a>
          <template slot="content">
            <div v-if="record.cargo_category === 1">
              <p v-if="record.detail['tank_number']"> 罐号: {{ record.detail['tank_number'] }}</p>
              <p v-if="record.detail['intake_date']"> 入罐日期: {{ record.detail['intake_date'] }}</p>
              <p v-if="record.detail['tank_inventory']"> 对应存量: {{ record.detail['tank_inventory'] }}</p>
              <p v-if="record.detail['shore_tank_qty']"> 岸罐数量: {{ record.detail['shore_tank_qty'] }}</p>
            </div>
            <div v-else-if="record.cargo_category === 2">
              <p v-if="record.detail['discharge_date']"> 卸货日期: {{ record.detail['discharge_date'] }}</p>
            </div>
            <div v-else-if="record.cargo_category === 3">
              <p v-if="record.detail['seal_number']"> 铅封号: {{ record.detail['seal_number'] }}</p>
              <p v-if="record.detail['container_type']"> 箱型: {{ record.detail['container_type'] }}</p>
              <p v-if="record.detail['container_count']"> 箱量: {{ record.detail['container_count'] }}</p>
            </div>
            <div>
              <p>毛重：{{ record.detail['gross_weight'] }}</p>
              <p>净重：{{ record.detail['net_weight'] }}</p>
              <p>单位：{{ unit[record.detail['unit']] }}</p>
            </div>
          </template>
        </a-popover>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archived_visible"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
    <watch-view
      ref="watchViewModal"
      v-if="watchViewVisible"
      :visible="watchViewVisible"
      :model="mdl"
      @cancel="watchViewVisible=false"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  lading_bill_list,
  lading_bill_create,
  lading_bill_delete,
  lading_bill_archived
} from '@/api/trade_lading_bill'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'
import WatchView from '../modules/WatchView'
import WatchViewForm from '@/views/a-trade/guarantee_contract/modules/WatchViewForm'

export default {
  name: 'TableList',
  components: {
    WatchViewForm,
    STable,
    CreateForm,
    WatchView,
    ArchivedForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      watchViewVisible: false,
      trade_lading_bill_type: this.$Dictionaries.trade_lading_bill_type,
      unit: this.$Dictionaries.unit,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '编号',
          dataIndex: 'number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '提单号',
          dataIndex: 'bill_of_lading_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 200,
          ellipsis: true
        },
        {
          title: '购销合同',
          dataIndex: 'sell_contract',
          width: 200,
          ellipsis: true
        },
        {
          title: '提单签发日期',
          dataIndex: 'bill_of_lading_date',
          width: 150,
          ellipsis: true
        },
        {
          title: '发货人',
          dataIndex: 'shipper',
          width: 150,
          ellipsis: true
        },
        {
          title: '承运人',
          dataIndex: 'carrier',
          width: 150,
          ellipsis: true
        },
        {
          title: '收货人',
          dataIndex: 'consignee',
          width: 150,
          ellipsis: true
        },
        {
          title: '通知方',
          dataIndex: 'notify_party',
          width: 150,
          ellipsis: true
        },
        {
          title: '装货港',
          dataIndex: 'loading_port',
          width: 150,
          ellipsis: true
        },
        {
          title: '卸货港',
          dataIndex: 'discharge_port',
          width: 150,
          ellipsis: true
        },
        {
          title: '货物扩展分类',
          dataIndex: 'cargo_category',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'cargoCategory' }
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 150,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return lading_bill_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: year + '' + month + '' + day + '' + hours + minutes }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchViewVisible = true
      // this.$router.push({ path: '/trade/bol/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/bol/' + record.id })
    },
    handleDelete (record) {
      lading_bill_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    createDetail (values) {
      const detail = {}
      if (values['cargo_category'] === '1') {
        detail['tank_number'] = values['tank_number']
        detail['tank_inventory'] = values['tank_inventory']
        detail['shore_tank_qty'] = values['shore_tank_qty']
        detail['intake_date'] = values['intake_date']
      } else if (values['cargo_category'] === '2') {
        detail['discharge_date'] = values['discharge_date']
      } else if (values['cargo_category'] === '3') {
        detail['container_type'] = values['container_type']
        detail['container_count'] = values['container_count']
        detail['seal_number'] = values['seal_number']
      }
      detail['gross_weight'] = values['gross_weight']
      detail['net_weight'] = values['net_weight']
      detail['unit'] = values['unit']
      return detail
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values['detail'] = this.createDetail(values)
          values['attachment'] = data.attachment
          this.confirmLoading = true
          lading_bill_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          lading_bill_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
